import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController} from 'ionic-angular';
import { SportBetPanelService, MobileSharedService, SharedService, BookBetService, SocketService, Status, User, Sportshome, SportsHomeService, sportsBetType, ConfigService} from 'baseline-lib';
import { Notify, SportsBetSlip} from 'baseline-lib';
import { BetRequest, BetPanel, MarketStatus } from 'baseline-lib';
import { BookBetPage } from '../../shared/book-bet/book-bet';
import { BehaviorSubject } from 'rxjs';
import { CustomToast } from '../../shared/services/custom-toast';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { Global } from '../../../global/global';
import { LoadingController} from 'ionic-angular';
import { HomePage } from '../../home/home/home';
import { SportsMenuPage } from '../sports-menu-page/sports-menu-page';
import { TranslateService } from '@ngx-translate/core';
import { Content } from 'ionic-angular';
import { RegisterModalPage } from '../../shared/register-modal/register-modal';


/**
 * Generated class for the SportsBetslipPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-sports-betslip',
  templateUrl: 'sports-betslip.html',
})
export class SportsBetslipPage {
  @ViewChild('pageTop') pageTop: Content;
  _notify: Notify;
  _sportsBetSlip: SportsBetSlip;
  currencySymbol: string;
  updates_sub: any;
  public _marketStatus = MarketStatus;
  bookABetObj: any[] = [];
  mybookbetservice : any;
  isbookbetpressed:Boolean = false;
  sportsHomeObj: Sportshome;
  inplay;
  betslipMenu : any;
  betCount = 0;
  public _sportsBetType = sportsBetType;


  constructor(public navCtrl: NavController, public globalData:Global,public navParams: NavParams,
    public _sportsBetpanelServices: SportBetPanelService,
    public mobileSharedService: MobileSharedService,
    public _sharedService: SharedService,
    public translate : TranslateService,
    public toast: CustomToast,
    public loadingCtrl: LoadingController,
    private _bookBetService: BookBetService,
    public modalCtrl : ModalController, public _configService : ConfigService,
    private _socketService: SocketService,public _sportsHomeService : SportsHomeService) {
      //this._sportsBetSlip = new SportsBetSlip();
      this.sportsHomeObj = new Sportshome();
      this._notify = new Notify();
      this._sportsBetSlip = this._sportsBetpanelServices.sportsBetSlip;
      this.currencySymbol = this._sharedService._sessionService.getCurrenySymbol();
  }

  ngOnDestroy() {
    if (this.updates_sub) {
      this.updates_sub.unsubscribe();
    }
  }

  ngOnInit() {
    this.sportsHomeObj = this._sportsHomeService.sportshomeobj;
    this.inplay = this.globalData.inPlay;
    // check if booked bet is available
    if (this._bookBetService.checkBookBetTicket)
      this._sportsBetpanelServices.processCheckBetsData(this._bookBetService.checkBookBetTicket);

    //subscript to load betslip if check book bet data available
    this._sportsBetpanelServices.bookBetPanelAvlbl.subscribe(data => {
      this._sportsBetSlip = this._sportsBetpanelServices.sportsBetSlip;
      //console.log(this._sportsBetSlip);
    });

    this.updateTabs();

    //subscript to book a load bet modal msg toggle
      this._sportsBetpanelServices.loadBookBetMsg.subscribe(data => {
        this._notify = new Notify();
        this._notify = data;
      });


    //start socket updates.
    this.updates_sub = this._socketService.updates.subscribe(data => {
      try {

        if (this._sportsBetpanelServices.sportsBetSlip.betpanels.length == 0)
          return;

        if (data) {
          let _socketData = JSON.parse(data.toString());
         
          if (this._sportsBetpanelServices.sportsBetSlip) {
            if (this._sportsBetpanelServices.sportsBetSlip.betpanels) {
              if (!_socketData.isscr) {
                if (_socketData) {
                  var _betpanels = this._sportsBetpanelServices.sportsBetSlip.betpanels.filter(a => a.eid == _socketData.id && a.bid == _socketData.amid); // search event
                  if (_betpanels.length > 0) {
                    let _betpanel: BetPanel;
                    _betpanels.forEach(_pnl => {
                      if (_pnl.sli.find(a => a == _socketData.sd)) {
                        _betpanel = _pnl;
                        return;
                      }
                    });

                    if (_betpanel || (_betpanels && _betpanels.length > 0)) {                      
                      let preStList = [];let curStList = [];                        
                      preStList = this.statusProcessing(_betpanel, _betpanels);
                      var _isUpdated = this._socketService.processUpdates_BetSlip(_socketData, _betpanel, _betpanels);  
                      curStList = this.statusProcessing(_betpanel, _betpanels);
                      if (_isUpdated || preStList[0] != curStList[0]) {                        
                        this.updateBetslip(preStList[0],curStList[0]);
                      }
                      else if(curStList.length > 1) {
                        for(let i=0; i<curStList.length; i++) {
                          if(curStList[i] != preStList[i]) {
                            this.updateBetslip(preStList[i],curStList[i]);
                            return;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

        }
      }
      catch (err) {
        console.log(err);
      }

    });

    // // segment active inactive code
    // if(this._sportsBetSlip.sysBets.length >1){
    //   if(this._sportsBetSlip.disableMultiple){ // disable multipl , show sysbet
    //     this.betslipMenu = "Multiple";
    //   }else{
    //     this.betslipMenu = "sysbet";
    //   }
    // }

  }

  updateTabs(){
    if(this._sportsBetSlip.betpanels.length > 0){
      if(this._sportsBetSlip.disableMultiple){
        this.betslipMenu = "Multiple";
      }else{
        this.betslipMenu = "sysbet";
      }
  }
  }

  calcTotalStakePanel(number : any){
    this._sportsBetpanelServices.calcTotalStakePanel(number);
  }

  public clearSlip() {
    this._sportsBetpanelServices.clearallBetPanels();
  }

  bookBet() {
    this.isbookbetpressed = true;
    if (this._sportsBetSlip && this._sportsBetSlip.betpanels.length > 0) {
      var betRequest = new BetRequest();
      betRequest = this._sportsBetpanelServices.generateBetRequestObj();
      if (this._sharedService.selectedGameType) {
        betRequest.gt = this._sharedService.selectedGameType.gtid;
        betRequest.gurl = this._sharedService.selectedGameType.url + '/' + this._sharedService.selectedGameType.gtid;
      }

      this._bookBetService.placeBookABet(betRequest).subscribe(
        data => {
          this.clearSlip();
        }
      ); 

      this._sharedService.openBookABet.unsubscribe();
      this._sharedService.openBookABet = undefined;
      this._sharedService.openBookABet = new BehaviorSubject<any>(null);
      this._sharedService.openBookABet.subscribe(data => {
          this.bookABetObj = undefined;
          if (data && data !=null && data.pli && data.pli.length > 0) {
            this.bookABetObj = data;
            let bookbetmodal = this.modalCtrl.create(BookBetPage, { data: this.bookABetObj });
            bookbetmodal.present();
          }
        });
       
    }
  }



  placeBet() {
    // this._notify.updateMsg = "active";
    // this._notify.suspended = false;
    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });
    loader.present();
    //check of uodated odds panels & reset the flag
   

    
    if (this.globalData.isLoggedIn && this.globalData.authUser) {
      //this._sharedService.showLoader();

      if (this._notify.updateMsg != '')
      this.hideUpdateMsg();

      if (this.betCount > 0) {
        let _updatedeBets = this._sportsBetSlip.betpanels.forEach(a => { if (a.wsUpdated) a.wsUpdated = false; });
        this.betCount = 0;
      }

     // setTimeout(() => {
        this._sportsBetpanelServices.placeBet().
          subscribe(
            (response: any) => {
              loader.dismiss();
              // this._sharedService.updateUserBalance(response.bal, response.ebal);
              this._sharedService.userBalanceUpdateGameType.next(response);
              this._sportsBetpanelServices.clearallBetPanels();
              this.translate.get('Transaction Successful').subscribe(
                value => 
                {
                  this.toast.showSuccess(value);
                });
              this.navCtrl.pop();
            },
            error => {
              loader.dismiss();
              if (error.message == "Suspended") { 
                this._notify.updateMsg = "active";
                this._notify.suspended = true;
                this.pageTop.scrollToTop();
              }
              else if ((error && error.status && error.status == 412) || (error && error.message && error.errorCode == 412)) {
                this.betCount++;
                this._notify.updateMsg = "active";
                this._notify.suspended = false;
                this.pageTop.scrollToTop();
                // if msg recieved from server update odds
                if (error.status) {
                  error.pli.forEach(_pnl => {
                    if(_pnl.oc)
                      this.processBetPanelUpdates(_pnl);
                  });
                }
              }
              else { 
                if (error.msg) {
                  this.toast.showError(error.msg);
                }
                else {
                  //this.errMessage = error.message;
                  this._sharedService.errmsg = error.message;
                  if (error.errorCode) 
                  {
                    if (error.errorCode == Status.unauthorised) 
                    {
                      this.toast.showError("Please Login to continue!");
                      console.log('logout emitter');
                      localStorage.clear(); //logout;
                      this.globalData.selectedMenu = "home";
                      this.globalData.isLoggedIn = false;
                      this.globalData.authUser = new User();
                      this._sportsBetpanelServices.clearallBetPanels();
                      // if(this._sharedService.timerSub)
                      //   this._sharedService.timerSub.unsubscribe();
                      if(!this._configService.isplayerLogin())
                        this.navCtrl.setRoot(HomePage); 
                      this._sharedService.loginSubject.next(false);
                      //loader.dismiss();
                    }
                  }else{
                    this.toast.showError(error.message);
                  }
                }
              }
            });
         // }, this._sportsBetpanelServices.sportsBetSlip.betpanels.filter(_panel => _panel.inplay == true).length > 0 ? 5000 : 0);
    }
    else {
      // this._sharedService.openLogin.next(true);
      loader.dismiss();
      let profileModal = this.modalCtrl.create(LoginModalPage);
       profileModal.present();    
    }
    this._bookBetService.checkBookBetTicket = new BetRequest();
  }

  hideUpdateMsg() {
    this._notify.updateMsg = '';
    this._notify.suspended = false;
  }
  
  processBetPanelUpdates(newBetPanel) { 
    this._sportsBetpanelServices.sportsBetSlip.betpanels.forEach(_pnl => {
      if (_pnl.pid == newBetPanel.pid) { 
        _pnl.isChanged = false;
            if (_pnl.odd < newBetPanel.nodd) {
              _pnl.odd = newBetPanel.nodd;
              _pnl.IsOddsHigh = true;
              _pnl.isChanged = true;
              setTimeout(() =>
                _pnl.isChanged = false
                , 3000);
            }
            else if (_pnl.odd > newBetPanel.nodd) {
              _pnl.odd = newBetPanel.nodd;
              _pnl.IsOddsHigh = false;
              _pnl.isChanged = true;
              setTimeout(() =>
                _pnl.isChanged = false
                , 3000);
            }
      }
    });
    this.updateBetslip();
  }


  removePanel(panel) {
    this._sportsBetpanelServices.removeBetPanel(panel);
    this.updateTabs();
  }
 
  private updateBetslip(preStatus?: number, curStatus?: number) {
    this._sportsBetpanelServices.sportsBetSlip.updateBetslip(preStatus, curStatus); 
    if ((preStatus != MarketStatus.Update && preStatus != 0) || (curStatus != MarketStatus.Update && curStatus != 0)) 
    { 
      this.updateTabs();
    }       
    this.sportsHomeObj.betSlipCount = this._sportsBetpanelServices.sportsBetSlip.filteredBetPanels.length;
  }

  private statusProcessing(_betpanel: BetPanel, _betpanels: BetPanel[]): number[] {
    let statusList = [];
    if(_betpanel) {
      statusList.push(_betpanel.status);      
    }
    else {
      statusList = _betpanels.map(_bet => _bet.status);                            
    }
    return statusList;
  }

  removeSuspendedPanels() {
    this._sportsBetpanelServices.sportsBetSlip.betpanels = this._sportsBetpanelServices.sportsBetSlip.betpanels.filter(a => a.status != MarketStatus.Settled &&
      a.status != MarketStatus.Deactivated &&
      a.status != MarketStatus.Suspended &&
      a.status != MarketStatus.Cancelled);

    this.updateBetslip();

    this.placeBet();
    this.hideUpdateMsg();
  }

  openSportsMenuPage()
  {
    this.navCtrl.push(SportsMenuPage,{
      fromBetSlip:"fromBetSlip"
      });
  }
  
  openBetSlipPage(){
    this.navCtrl.push(SportsBetslipPage);
  }

  onKey(event: any, index: number) { // without type info       
    this._sportsBetpanelServices.calcTotalStakePanel(index);
  }

  loginClicked()
  {
    let profileModal = this.modalCtrl.create(LoginModalPage);
    profileModal.present();    
  }

  registerClicked()
  {
    let registerModal = this.modalCtrl.create(RegisterModalPage);
    registerModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/app/sports/sports-betslip/sports-betslip.ts